import { useMemo } from 'react';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import generateNaturalLanguageSearchUrl from '../utils/naturalLanguageUtils';

const useNaturalLanguageSearch = (handleAiSearchOverride?: (param: string) => void) => {
  const languageRegionCode = useLanguageRegionCode();

  const handleAiSearch = useMemo(
    () =>
      handleAiSearchOverride
        ? handleAiSearchOverride
        : (nlq: string) => {
            const route = generateNaturalLanguageSearchUrl(nlq, languageRegionCode);
            window.location.href = route;
          },
    [handleAiSearchOverride, languageRegionCode]
  );

  return useMemo(() => ({ handleAiSearch }), [handleAiSearch]);
};

export default useNaturalLanguageSearch;
